import { DEFAULT_LOCALE, DE_LOCALE, FR_LOCALE } from '@core/Constants/Locale.constants';

const CONDITION_TYPES = [
  {
    id: 'stock-condition-both',
    label: 'All',
    value: undefined,
    locales: [DEFAULT_LOCALE, FR_LOCALE, DE_LOCALE],
  },
  {
    id: 'stock-condition-used',
    label: 'Used',
    value: 'used',
    locales: [DEFAULT_LOCALE],
  },
  {
    id: 'stock-condition-new',
    label: 'New',
    value: 'new',
    locales: [DEFAULT_LOCALE, FR_LOCALE, DE_LOCALE],
  },
];

const currentYear = new Date().getFullYear();
const TEST_RANGE = Array.from({ length: currentYear - 2013 }, (_, index) => 2014 + index);

export { TEST_RANGE, CONDITION_TYPES };
